// store/slices/userSlice.ts
import { StateCreator } from "zustand";
import { User } from "@/types";

export interface UserSlice {
  user: User | null;
  _hasHydrated: boolean;
  /** In-memory only: set by an explicit sign-out so the guard never forwards
   * into a portal session; a real sign-in or the login page clears it. */
  signedOutByUser: boolean;
  setUser: (user: User | null) => void;
  setHasHydrated: (hydrated: boolean) => void;
  logout: () => void;
  signOut: () => void;
  clearSignedOutByUser: () => void;
}

export const createUserSlice: StateCreator<UserSlice> = (set) => ({
  user: null,
  _hasHydrated: false,
  signedOutByUser: false,
  setUser: (user) =>
    set((state) => ({
      user,
      signedOutByUser: user === null ? state.signedOutByUser : false,
    })),
  setHasHydrated: (hydrated) => set({ _hasHydrated: hydrated }),
  logout: () => {
    set({ user: null });
    // persist middleware handles app-storage, just clear legacy key
    localStorage.removeItem('user');
  },
  signOut: () => {
    set({ user: null, signedOutByUser: true });
    localStorage.removeItem('user');
  },
  clearSignedOutByUser: () => set({ signedOutByUser: false }),
});
